import store from '../../redux/store'

/* Normalize user identity values so Erised and HR users can be matched. */
export const read_identity_value = (value) => {
    return `${value || ''}`.trim().toLowerCase()
}

/* Read the authenticated user currently saved by the auth guard. */
export const read_current_user = () => {
    return store.getState()?.user?.user || {}
}

/* Read every identity key this app may receive from Erised or Dolores. */
export const read_user_identity_keys = (user) => {
    const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim()

    return [
        user?.userId,
        user?.id,
        user?._id,
        user?.sub,
        user?.email,
        user?.username,
        user?.preferred_username,
        user?.name,
        fullName
    ].map((value) => read_identity_value(value)).filter(Boolean)
}

/* Match the auth user to the saved HR admin row when it exists. */
export const find_current_team_user = (users, currentUser) => {
    const currentUserKeys = read_user_identity_keys(currentUser)

    return users.find((user) => {
        return read_user_identity_keys(user).some((key) => currentUserKeys.includes(key))
    }) || false
}

/* Build one user-like object for matching requests against the current account. */
export const read_current_user_matcher = (currentTeamUser, currentUser) => {
    return {
        userId: currentTeamUser?.userId || currentUser?.sub,
        id: currentTeamUser?.id || currentUser?.id,
        _id: currentTeamUser?._id,
        email: currentTeamUser?.email || currentUser?.email,
        username: currentTeamUser?.username || currentUser?.preferred_username,
        roles: currentTeamUser?.roles || currentUser?.roles || [],
        department: currentTeamUser?.department || ''
    }
}
